import { useTranslation } from "react-i18next";

import { Link } from "@/components/Interface/Link/Link";
import { Notification } from "@/components/Interface/Notification/Notification";

export const GoToShopSection = ({
  isOnboarding,
}: {
  isOnboarding?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Notification
      dataTestid="go-to-shop"
      title={t("Onboarding.sections.sim-selection.noSimCardTitle")}
      description={
        <div className="flex flex-col items-start gap-1">
          <p>{t("Onboarding.sections.sim-selection.noSimCardText")}</p>
          <Link
            href={
              // Redirect to homepage to receive free trial
              // Only onboarding users are eligible (see T-1053)
              isOnboarding
                ? t("Onboarding.sections.sim-selection.homepageLink")
                : t("Onboarding.sections.sim-selection.shopLink")
            }
            size="sm"
            target="_blank"
            rel="noreferrer"
          >
            {t("Common.label.toShop")}
          </Link>
        </div>
      }
      tone="info"
    />
  );
};
